<template>
  <div>
    <tree-crud :cfg="conf" :timestamp="timestamp"></tree-crud>
  </div>
</template>
<script>
import { TreeCrud } from "javaee-fre";

const LangSettings = () => import("../views/lang-settings.vue");

function quesCrud(itemId) {
  return {
    url: "/home/admin/c/courseware/item/ques",
    params: { _itemId: itemId },
    createable: false,
    forceEditFormStretch: true,
    listActions: [
      {
        label: "添加",
        func() {
          let self = this,
            dialog = self.$dialog;
          dialog.crud(
            "从收藏中选择题目",
            {
              url: "/home/my/favorite",
              params: { _type: 3 },
              selectStyle: "single",
            },
            [
              {
                label: "确认添加",
                color: "primary",
                func(sel) {
                  if (!sel) {
                    return;
                  }
                  let ids = Object.keys(sel);
                  if (ids.length < 1) {
                    return;
                  }
                  let tmp = { ...quesCrud(itemId) };
                  tmp.params._qid = sel[ids[0]].targetId;
                  tmp.initPanel = "edit";
                  tmp.createable = true;
                  tmp.onSaveSuccess = function () {
                    dialog.crud("设置题目", quesCrud(itemId));
                  };
                  setTimeout(() => {
                    dialog.crud("设置题目", tmp);
                  }, 100);
                },
              },
            ]
          );
        },
      },
    ],
  };
}
export default {
  name: "admin-courseware-editor",
  components: {
    "tree-crud": TreeCrud,
  },
  data() {
    return {
      conf: null,
      timestamp: Date.now(),
    };
  },
  watch: {
    $route() {
      this.init();
    },
  },
  methods: {
    init() {
      let self = this,
        id = self.$route.params.id,
        readOnly = self.$route.meta.readOnly;

      self.conf = {
        url: "/home/admin/c/courseware/item",
        tree: {
          items: [{ label: "课件大纲", id: 0, itemCount: 1 }],
          label: "label",
          id(i) {
            return i.id;
          },
          hasChildren(i) {
            return i.itemCount && i.itemCount > 0;
          },
          url(i) {
            return `/home/admin/c/courseware/item/list/0/100?_cwid=${id}&_pid=${i ? i.id : 0
              }`;
          },
        },
        crud: {
          createable: !readOnly,
          editable: !readOnly,
          deleteable: false,
          titleField: 'label',
          genParams(i) {
            return { _cwid: id, _pid: i ? i.id : 0 };
          },
          listActions() {
            let self = this,
              a = self.$store.state.account,
              otid = a.originTenantId;
            if (otid == 0 && !readOnly) {
              return [
                {
                  whereSel: false,
                  label: "导出",
                  func() {
                    let self = this;
                    window.open(
                      `${self.$const.baseUrl}/home/admin/c/courseware/item/export/summary?_cwid=${id}`
                    );
                  },
                },
              ];
            }
            return [];
          },
          listItemActions() {
            let self = this, iacts = [
              {
                label: "播放视频",
                icon: "play_circle_outline",
                func(cfg) {
                  let self = this,
                    mediaIds = cfg.item.mediaIds;
                  if (mediaIds && mediaIds.length > 0) {
                    let medias = mediaIds.split(",");
                    if (medias.length == 1) {
                      self.$axios
                        .get(`/home/my/media/cc/url/${medias[0]}`)
                        .then((r) => {
                          if (
                            r.data &&
                            r.data.status == "ok" &&
                            r.data.message
                          ) {
                            self.$dialog.component(
                              cfg.item.label,
                              "cc-video-viewer",
                              {
                                movieUrl: r.data.message,
                              }
                            );
                          }
                        });
                    } else {
                      self.$dialog.component(
                        "课件视频预览",
                        "courseware-medias-view",
                        { mediaIds: medias }
                      );
                    }
                  }
                },
              },
            ];

            if (!readOnly) {
              iacts.push(
                {
                  label: "设置视频",
                  icon: "movie",
                  func(cfg) {
                    let self = this;
                    self.$dialog.crud(
                      "从收藏中选择视频",
                      {
                        url: "/home/my/favorite",
                        params: { _type: 1 },
                        editable: false, deleteable: false,
                        selectStyle: "multi",
                      },
                      [
                        {
                          label: "确认",
                          color: "primary",
                          func(sel, arr) {
                            if (!arr) {
                              return;
                            }

                            let ids = arr.map((r) => r.targetId).join(",");

                            self.$axios
                              .get(
                                `/home/admin/c/courseware/item/set/medias/${cfg.item.id}`,
                                { params: { medias: ids, _cwid: id } }
                              )
                              .then((r) => {
                                if (r.data) {
                                  if (r.data.status == "ok") {
                                    self.$status("设置成功!", "success");
                                    self.refresh();
                                  } else {
                                    self.$status(
                                      r.data.message || "设置失败！",
                                      "error"
                                    );
                                  }
                                }
                              });
                          },
                        },
                      ]
                    );
                  },
                },
                {
                  order: -1,
                  label: "清空视频",
                  icon: "label_off",
                  confirm: "确定清空视频吗？",
                  func(cfg) {
                    let self = this;
                    self.$axios
                      .get(
                        `/home/admin/c/courseware/item/clear/medias/${cfg.item.id}`,
                        { params: { _cwid: id } }
                      )
                      .then(() => {
                        self.refresh();
                      });
                  },
                },
                {
                  label: "设置学时",
                  icon: "access_time",
                  func(cfg) {
                    let self = this;
                    self.$parent.onEdit(cfg.item.id, { _score: true });
                  },
                },
                {
                  order: -2,
                  label: "设置题目",
                  icon: "title",
                  func(cfg) {
                    let self = this;
                    self.$dialog.crud("设置题目", quesCrud(cfg.item.id));
                  },
                }
              );

              if (self.$isInRole('ROLE_SUPER')) {
                iacts.push({
                  order: -3,
                  label: '语言设置', icon: 'language', func(cfg) {
                    let self = this;
                    self.$dialog.component(`语言设置 - ${cfg.item.label}`, LangSettings, {
                      width: 800, fields: [
                        { category: 1, type: 3, categoryId: id, targetId: cfg.item.id, label: '名称', others: { label: '视频编号（多个用英文逗号隔开）' } }
                      ]
                    });
                  }
                });
              }
            }
            return iacts;
          },
          listItemFilter(i, acts) {
            if (i.itemCount == 0) {
              if (!i.mediaIds || i.mediaIds.length == 0) {
                this.delAction(acts, "icon", "play_circle_outline");
                if (!readOnly) {
                  this.delAction(acts, "icon", "label_off");
                  this.delAction(acts, "icon", "access_time");
                  this.delAction(acts, "icon", "title");
                }
              }
            } else {
              this.delAction(acts, "icon", "play_circle_outline");
              if (!readOnly) {
                this.delAction(acts, "icon", "label_off");
                this.delAction(acts, "icon", "access_time");
                this.delAction(acts, "icon", "movie");
                this.delAction(acts, "icon", "title");
              }
            }
            return acts;
          },
        },
      };
    },
  },
  created() {
    this.init();
  },
};
</script>
